import(/* webpackMode: "eager", webpackExports: ["ByoidProvider"] */ "/app/src/app/_components/NDR/ByoidProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Top5Wrapper"] */ "/app/src/app/_components/NDR/Wrappers/Top5Wrapper.tsx");
